// Simple offline queue using idb-keyval. Cases created while offline are stored locally
// and replayed when back online.
import { set, get } from "idb-keyval";
import { api } from "@/lib/api";

const QUEUE_KEY = "icos_offline_case_queue";

async function readQueue() { return (await get(QUEUE_KEY)) || []; }
async function writeQueue(q) { await set(QUEUE_KEY, q); }

export async function queueCase(payload) {
  const q = await readQueue();
  q.push({ id: crypto.randomUUID(), payload, queued_at: new Date().toISOString() });
  await writeQueue(q);
  window.dispatchEvent(new CustomEvent("icos-offline-queue-changed"));
}

export async function getQueue() { return readQueue(); }

export async function flushQueue() {
  const q = await readQueue();
  const remaining = [];
  for (const item of q) {
    try { await api.post("/cases", item.payload); }
    catch { remaining.push(item); }
  }
  await writeQueue(remaining);
  window.dispatchEvent(new CustomEvent("icos-offline-queue-changed"));
  return { synced: q.length - remaining.length, remaining: remaining.length };
}

// Auto-flush when online
if (typeof window !== "undefined") {
  window.addEventListener("online", () => { flushQueue(); });
}
